export function selectCalculatedPremium(state) {
  if (state.selectedProduct === null) {
    return 0;
  }

  // Basis-Prämie: 0.8% der Versicherungssumme pro Jahr
  let basisPraemie = state.selectedProduct.premium?.gross;

  // Zusatzoptionen hinzufügen
  const optionsPrice = state.formData.selectedOptions.reduce((sum, optionId) => {
    const option = state.selectedProduct.options.find(opt => opt.code === optionId);
    return sum + (option ? option.premium.gross : 0);
  }, 0);

  basisPraemie += optionsPrice;

  // Je nach Zahlungsintervall anpassen
  const period = state.availablePaymentPeriods.find(p => p.code === state.formData.zahlungsintervall);

  return basisPraemie * (period ? period.factor : 1);
}

export function selectMaxCoveredValue(state) {
  const allAvailableProducts = state.configuration?.products || [];
  if (allAvailableProducts.length === 0) {
    return 0;
  }
  return Math.max(...allAvailableProducts.map(product => product.maximumCoveredValue));
}
